import React, { useState, useRef, useEffect } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";

const GestionarScript = () => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtScript = useRef();
  const cmbBaseDatos = useRef();

  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [body, setBody] = useState(null);
  const [baseDatos, setBaseDatos] = useState([]);
  const [habilitado, setHabilitado] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [botones, setBotones] = useState({
    incluir: false,
    aceptar: true,
    cancelar: true,
  });

  const onChangeValidar = () => {
    let sigue = true;
    if (!botones.incluir || !botones.modificar) {
      if (txtScript.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Ingrese el Script",
          icono: "informacion",
        });
        sigue = false;
        txtScript.current.focus();
      } else if (baseDatos.length === 0) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "debe seleccionar una base de datos",
          icono: "informacion",
        });
        sigue = false;
        cmbBaseDatos.current.focus();
      }
    }

    if (sigue) {
      let database = [];

      if (cmbBaseDatos.current.value === "") {
        database = baseDatos;
        database.push({
          idbasedatos: "0",
          nombre: "plantilla",
          ip: "3.144.143.71",
          puerto: "5432",
        });
      } else {
        for (let i = 0; i < baseDatos.length; i++) {
          if (cmbBaseDatos.current.value === baseDatos[i].idbasedatos) {
            database.push(baseDatos[i]);
          }
        }
      }

      setBody({
        database: database,
        comando: txtScript.current.value.trim(),
      });

      let msg = "";
      if (!botones.incluir) {
        msg = "Esta Seguro de Correr este Script.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/athos/base/psql`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Proceso ejecutado correctamente",
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Error al Ejecutar el Script",
          icono: "error",
        });
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const seleccionarBasedeDatos = () => {
    let campos = "*";
    let nomtab = "basedatos";
    let orden = "idbasedatos";
    let endpoint = `${op.conexion}/api/athos/consulta/seleccionarregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setBaseDatos(response.data);
          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op !== 6) {
      setVisibleBtn("hidden");
    } else {
      setVisibleBtn("visible");
    }

    if (op === 1) {
      setHabilitado(false);
      setBotones({
        incluir: false,
        aceptar: false,
        cancelar: false,
      });
      cmbBaseDatos.current.focus();
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      blanquear();
    }
  };

  const blanquear = () => {
    txtScript.current.value = "";
    cmbBaseDatos.current.value = "";

    setActivate(false);
    setBody(null);
    setHabilitado(true);
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    setVisibleBtn("visible");
    setBotones({
      incluir: false,
      aceptar: true,
      cancelar: true,
    });
  };

  useEffect(() => {
    seleccionarBasedeDatos();
  }, []);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="col-md-12 mx-auto row">
        <div className="col-md-12 py-2 row card">
          <div className="col-md-12 mx-auto rounded py-2  border-azul ">
            <div className=" row rounded px-0 d-flex justify-content-between">
              <div className="input-group mb-3 input-group-sm col-sm-12">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Base de Datos:
                </label>
                <select
                  className="form-select"
                  aria-label="Default select example col-md-4"
                  name="conexion"
                  disabled={habilitado}
                  ref={cmbBaseDatos}
                >
                  <option value={""}>TODAS LAS BASES DE DATOS</option>
                  {baseDatos &&
                    baseDatos.map((item, index) => (
                      <option key={index} value={item.idbasedatos}>
                        {" "}
                        {item.nombre.toUpperCase()}{" "}
                      </option>
                    ))}
                </select>
              </div>
              <div className="input-group mb-3 input-group-sm col-sm-12">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  {" "}
                  Script:
                </label>
                <textarea
                  disabled={habilitado}
                  name="script"
                  ref={txtScript}
                  style={{ height: 300 }}
                  className="form-control text-uppercase"
                  id="textAreaExample"
                ></textarea>
              </div>
            </div>

            <div className="col-md-12 mt-2 d-flex justify-content-end">
              {visibleBtn === "visible" ? (
                <div
                  className="col-md-12 d-flex justify-content-start"
                  style={{ visibility: visibleBtn }}
                >
                  <button
                    disabled={botones.incluir}
                    onClick={onBotones(1)}
                    className="btn btn-sm mx-1 btn-primary rounded-pill"
                    style={{ height: "27px" }}
                    title="Correr Script"
                  >
                    <i style={{ fontSize: "9px" }} className="fas fa-plus">
                      {" "}
                      Correr Script
                    </i>{" "}
                  </button>
                </div>
              ) : (
                <div
                  className="col-md-5 d-flex justify-content-end"
                  style={{
                    visibility: visibleBtn === "visible" ? "hidden" : "visible",
                  }}
                >
                  <button
                    disabled={botones.aceptar}
                    onClick={onBotones(5)}
                    ref={btnAcepta}
                    style={{ height: "27px" }}
                    className="mx-2 btn btn-sm rounded-pill btn-success"
                  >
                    <i
                      className="fas fa-check-circle"
                      style={{ fontSize: "9px" }}
                    >
                      {" "}
                      Aceptar
                    </i>
                  </button>
                  <button
                    disabled={botones.cancelar}
                    onClick={onBotones(6)}
                    ref={btnCancela}
                    style={{ height: "27px" }}
                    className="mx-2 btn btn-danger btn-sm rounded-pill"
                  >
                    <i
                      className="fas fa-window-close"
                      style={{ fontSize: "9px" }}
                    >
                      {" "}
                      Cancelar
                    </i>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default GestionarScript;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/gestionDataScript.js